export default __webpack_public_path__ + "static/media/11.5493ca0f.jpg";